import { LifeConstants } from '@tymbe/schema/constants/life_constants';
import { Banner, BannerType } from '../../../../components/Banner/Banner';

type Props = {
  originalLives: number;
  newLives: number;
};

const getConsequence = ({
  originalLives,
  newLives,
}: Props): [BannerType, string] => {
  if (
    newLives <= LifeConstants.banThreshold &&
    originalLives > LifeConstants.banThreshold
  ) {
    return ['error', 'Tymber dostane ban a zruší se mu vsěchny směny.'];
  }
  if (
    newLives > LifeConstants.banThreshold &&
    originalLives <= LifeConstants.banThreshold
  ) {
    if (newLives > LifeConstants.onlyRescueShiftThreshold) {
      return [
        'success',
        'Tymberovi se zruší ban - bude se moci hlásit na všechny směny.',
      ];
    }
    return [
      'success',
      'Tymberovi se zruší ban - bude se moci hlásit pouze na záchranářské směny a příjmat pozvánky.',
    ];
  }

  if (
    newLives <= LifeConstants.onlyRescueShiftThreshold &&
    originalLives > LifeConstants.onlyRescueShiftThreshold
  ) {
    return [
      'warning',
      'Tymberovi se zruší přihlásené směny - bude se moci hlásit pouze na záchranářské směny a příjmat pozvánky.',
    ];
  }

  if (
    newLives > LifeConstants.onlyRescueShiftThreshold &&
    originalLives <= LifeConstants.onlyRescueShiftThreshold
  ) {
    return [
      'success',
      'Tymber se bude moci hlásit na všechny přihlásené směny.',
    ];
  }

  return ['info', 'Žádná změna'];
};

export const TyLivesConsequenceInfo = ({ originalLives, newLives }: Props) => {
  const [type, consequence] = getConsequence({ originalLives, newLives });

  return <Banner type={type} title="Změna způsobí" message={consequence} />;
};
